import { IBaseConfig } from "../gameLoader/types/IGameLoader.types";
import {parseHtmlToJson} from "./parseHtmlToJson";

export const parseFiltersConfigs = (
    document: Document
): Map<string, IBaseConfig> => {
    if (!document) {
        return new Map<string, IBaseConfig>();
    }

    const map = new Map<string, IBaseConfig>();

    const filtersDocuments = Array.from(
        document.querySelectorAll("config > filters > *")
    );

    for (let i = 0; i < filtersDocuments.length; i++) {
        const filterDocument = filtersDocuments[i];

        const configs = Array.from(filterDocument.children).reduce(
            (object: Object, child: Element) => ({
                ...object,
                [child.tagName]:
                    child.textContent?.replace(/\\n/g, "").trim()
                    || prepareHtmlToJson(child.innerHTML),
            }),
            {}
        ) as IBaseConfig;

        map.set(filterDocument.tagName, configs);
    }

    return map;
};

const prepareHtmlToJson = (html: string): any => {
    if (!html || !html.trim()) {
        return '';
    }

    const rawHtml = html.replace(/\\n/g, "")
        .replace(/>\s+</g, '><').trim();

    try {
        return parseHtmlToJson(rawHtml);
    } catch (e: any) {
        console.warn('Parse HTML error:', e.message);
        return '';
    }
};
